/** Joins class names, dropping falsy parts. Internal design-system helper. */
export function cx(...parts: (string | false | null | undefined)[]): string {
  return parts.filter(Boolean).join(' ')
}

/** Builds an aria-describedby value from optional ids. */
export function describedBy(...ids: (string | false | null | undefined)[]): string | undefined {
  const value = ids.filter(Boolean).join(' ')
  return value.length > 0 ? value : undefined
}
